module.exports = __webpack_public_path__ + "fonts/Nunito-SemiBoldItalic.cc0b18c.ttf";